var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favoriteBalloon"},[(_vm.isRegister)?[_c('div',{staticClass:"favoriteBalloon_on"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]:[_c('div',{staticClass:"favoriteBalloon_off"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }